import React, { useMemo } from 'react'
import BreadcrumbTab from '../../../../common/BreadcrumbTab'
import ChatWithUs from '../../Forms/ChatWithUs'
import LifetimeReplacementModule from './module/LifetimeReplacementModule'
import { rmaLRPage } from './constant'
import useManageActionButton from './hooks/useManageActionButton'
import { LRContainer } from './style/LifetimeReplacement.css'
import { LRContainerWmo } from './style/LifetimeReplacementWmo.css'
import useManageItemDetail from './hooks/useManageItemDetail'
import { eligibleStatuses } from '../../Forms/constant'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'

const tabData = ['Details', 'Confirmation']

const LifetimeReplacement = ({ moduleData }) => {
  const {
    isDesktop,
    partSku,
    orderDetails,
    selectedPart,
    buttonLabel,
    submitSelect,
    setReturnQuantity,
    handleReason,
    tokenCustomerId,
    GTM,
  } = { ...moduleData }

  const {
    page,
    returnId,
    submitForm,
    submitLoading,
  } = useManageActionButton({
    orderDetails,
    partSku,
    handleReason,
    tokenCustomerId,
    GTM,
  })

  const item = useManageItemDetail({
    orderDetails,
    partSku,
    selectedPart,
    eligibleStatuses,
    buttonLabel,
    submitSelect,
  })

  const currentActivePage = page === rmaLRPage.detail ? 0 : 1

  const currentData = useMemo(() => ({
    type: page,
    submitForm,
    isDesktop,
    partSku,
    orderDetails,
    item,
    setReturnQuantity,
    returnId,
    submitLoading,
  }), [
    page,
    submitForm,
    isDesktop,
    partSku,
    orderDetails,
    item,
    setReturnQuantity,
    returnId,
    submitLoading,
  ])

  const isWmoEnabled = useWmoEnabled();

  if(isWmoEnabled){
    return (
      <LRContainerWmo>
        <LifetimeReplacementModule data={currentData} />
      </LRContainerWmo>
    )
  }

  return (
    <LRContainer>
      <BreadcrumbTab
        data={tabData}
        bgColor="#a3a3a3"
        bgActiveColor="#333"
        activeStep={currentActivePage}
      />
      <LifetimeReplacementModule data={currentData} />
      <ChatWithUs />
    </LRContainer>
  )
}

export default LifetimeReplacement
